import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { GalleriaModule } from 'primeng/galleria';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { GallerySelector, GalleryService } from './gallery.serice';

export interface GalleryItem {
    type: 'image' | 'video';
    src: string;
    alt: string;
}

@Component({
    selector: 'app-gallery',
    standalone: true,
    imports: [CommonModule, GalleriaModule, ButtonModule, TagModule],
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit {
    items: GalleryItem[] = [];
    reference: any[] = [];
    selector: GallerySelector | null = null;
    selectedOptionId: string = '';
    lightboxVisible = false;
    activeIndex = 0;
    title: string = '';
    token: string = '';
    responsiveOptions = [
        { breakpoint: '1024px', numVisible: 5 },
        { breakpoint: '768px', numVisible: 3 },
        { breakpoint: '560px', numVisible: 1 },
    ];

    constructor(
        private route: ActivatedRoute,
        private galleryService: GalleryService
    ) { }

    ngOnInit(): void {
        // Get token from route
        const token = this.route.snapshot.paramMap.get('token');
        if (token) {
            this.token = token;
            this.loadGallery(token);
        }
    }

    loadGallery(token: string, selectedId?: string): void {
        this.galleryService.getGalleryItems(token, selectedId).subscribe({
            next: (data) => {
                console.log('data', data)
                this.items = data.items;
                this.title = data.reference.title
                this.reference = data.reference.stats;
                this.selector = data.selector;
                this.selectedOptionId = data.selector?.selectedId || '';
                this.activeIndex = 0;
                this.lightboxVisible = false;
                console.log('this.reference', this.reference)
            },
            error: (err) => console.error('Failed to load gallery', err),
        });
    }

    onSelectorChange(event: Event): void {
        const selectedId = (event.target as HTMLSelectElement).value;
        if (!selectedId || !this.token) {
            return;
        }

        this.selectedOptionId = selectedId;
        this.loadGallery(this.token, selectedId);
    }

    onSelectionChange(event: Event): void {
        this.onSelectorChange(event);
    }

    openLightbox(index: number): void {
        this.activeIndex = index;
        this.lightboxVisible = true;
    }

    onActiveIndexChange(index: number): void {
        this.activeIndex = index;
    }

    get hasItems(): boolean {
        return this.items.length > 0;
    }

    trackByIndex(index: number, item: GalleryItem) {
        return item.src; // use src as a unique identifier
    }
}
